import * as actions from 'actions';

const INITIAL_STATE = {
  hasRunningLiveThreads: false,
  localWatchedThreadId: null,
  remoteWatchedThreadId: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.FORUM_STATUS_UPDATE: { // This update comes from the server.
      const { live, thread } = action.status;

      return {
        ...state,
        hasRunningLiveThreads: live.length > 0,
        remoteWatchedThreadId: thread
      };
    }

    case actions.FORUM_THREAD_WATCH:
      return {
        ...state,
        localWatchedThreadId: action.forumThread.id
      };

    case actions.FORUM_THREAD_UNWATCH:
      return {
        ...state,
        localWatchedThreadId: null
      };

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/status/reducer.js
 **/